module.exports = __webpack_public_path__ + "img/request_icon.98ae355d.png";